/**
 * IR imgPosCoords 폴백으로 RGB GeoImage를 붙일 때,
 * 링을 사진 TL→TR→BR→BL (경위도 CW, 윗변 왼→오)로 맞춘다.
 * CCW면 첫 변이 반대라 GeoImage 회전이 180° 뒤집힌다.
 */

function openQuad(ring) {
  if (!Array.isArray(ring) || ring.length < 4) {
    return null;
  }
  const first = ring[0];
  const last = ring[ring.length - 1];
  const closed =
    first &&
    last &&
    Number(first[0]) === Number(last[0]) &&
    Number(first[1]) === Number(last[1]);
  const open = closed ? ring.slice(0, -1) : ring.slice();
  if (open.length < 4) {
    return null;
  }
  const pts = open.slice(0, 4).map(pt => [Number(pt[0]), Number(pt[1])]);
  if (pts.some(pt => !Number.isFinite(pt[0]) || !Number.isFinite(pt[1]))) {
    return null;
  }
  return pts;
}

function closeRing(pts) {
  return [...pts, [pts[0][0], pts[0][1]]];
}

function signedArea(pts) {
  let area = 0;
  for (let i = 0; i < pts.length; i += 1) {
    const [x1, y1] = pts[i];
    const [x2, y2] = pts[(i + 1) % pts.length];
    area += x1 * y2 - x2 * y1;
  }
  return area;
}

function edgeLength(a, b) {
  return Math.hypot(b[0] - a[0], b[1] - a[1]);
}

export function firstEdgeHeadingDeg(ring) {
  const pts = openQuad(ring);
  if (!pts) {
    return NaN;
  }
  return (Math.atan2(pts[1][1] - pts[0][1], pts[1][0] - pts[0][0]) * 180) / Math.PI;
}

/**
 * @param {number[][]} ring
 * @returns {number[][] | *}
 */
export function normalizeQuadRingForPhotoTopLeftToRight(ring) {
  const pts = openQuad(ring);
  if (!pts) {
    return ring;
  }
  if (signedArea(pts) <= 0) {
    return closeRing(pts);
  }
  const len01 = edgeLength(pts[0], pts[1]);
  const len12 = edgeLength(pts[1], pts[2]);
  const remapped =
    len01 >= len12
      ? [pts[1], pts[0], pts[3], pts[2]]
      : [pts[0], pts[3], pts[2], pts[1]];
  return closeRing(remapped);
}

/**
 * @param {object | null | undefined} imgPosCoords
 * @returns {object | null | undefined}
 */
export function normalizeImgPosCoordsForRgbIrFallback(imgPosCoords) {
  if (!imgPosCoords) {
    return imgPosCoords;
  }
  const raw = imgPosCoords.coordinates ?? imgPosCoords;
  const ring = Array.isArray(raw?.[0]?.[0]) ? raw[0] : raw;
  const normalized = normalizeQuadRingForPhotoTopLeftToRight(ring);
  if (!Array.isArray(normalized)) {
    return imgPosCoords;
  }
  if (imgPosCoords.coordinates) {
    return {
      ...imgPosCoords,
      coordinates: [normalized]
    };
  }
  return normalized;
}

export function shouldNotifyRgbPositionFallback(hasRgbOwnPos, didPlaceOnMap) {
  return didPlaceOnMap === true && hasRgbOwnPos !== true;
}
